export function createNoContentRow(columnsCount: number): HTMLTableRowElement {
  const tr = document.createElement('tr')
  const td = document.createElement('td')
  td.part = 'cell'
  td.colSpan = columnsCount
  const slotElement = document.createElement('slot')
  slotElement.name = 'no-results'
  td.appendChild(slotElement)
  tr.appendChild(td)
  return tr
}
